export default {
	shippingRate: window.shippingRate, // This is the flat shipping rate applied to all orders with a shippable item
	shippingFee: 0, // This is the ACTUAL shipping fee applied to this order
	init() {
		try {
			this.items = JSON.parse(localStorage.getItem('cart') ?? "{}")
			this.coupon = JSON.parse(localStorage.getItem('coupon') ?? "''")
		} catch (e) {
			this.items = {}
		}
		Alpine.effect(() => {
			// Store cart & coupon to localStorage for persistence
			localStorage.setItem('cart', JSON.stringify(this.items))
			localStorage.setItem('coupon', JSON.stringify(this.coupon))
			
			// Apply shippingRate when necessary
			let needsRate = false;
			for (const key of Object.keys(this.items)) {
				const item = this.items[key]
				if (item.ean && item.ean !== '') {
					needsRate = true;
				}
			}
			if (needsRate) {
				this.shippingFee = this.shippingRate	
			} else {
				this.shippingFee = 0
			}
		})

		if(window.location.hash == '#details') {
			this.step = 1;
		} else if(window.location.hash == '#payment') {
			this.step = 2;
		}

	},	
	nextText: 'Proceed to Checkout',
	items: {},
	coupon: false,
	step: 0,
	get total() {
		let keys = Object.keys(this.items)
		let itemTotal = keys.reduce((c, i) => {
			let price = 0;
			if (this.items[i].discountedPrice != false) {
				price = this.items[i].discountedPrice
			} else {
				price = this.items[i].price
			}
			return c + (price * this.items[i].amount)
		}, 0);
		return itemTotal + this.shippingFee;
	},
	get formattedTotal() {
		const formatter = new Intl.NumberFormat('en-GB', {
		  style: 'currency',
		  currency: 'GBP',
		});
		return formatter.format(this.total)
	},
	get formattedShippingFee() {
		const formatter = new Intl.NumberFormat('en-GB', {
		  style: 'currency',
		  currency: 'GBP',
		});
		return formatter.format(this.shippingFee)
	},
	get shouldShowCart() {
		return true
	},
	addItem(itemId, itemPrice, itemDiscountPrice, itemTitle, itemCover, itemEan) {
		this.items[itemId] = {
			price: itemPrice,
			discountedPrice: itemDiscountPrice,
			amount: 1,
			title: itemTitle,
			cover: itemCover,
			ean: itemEan
		}
	},
	changeItemAmount(itemId, amount) {
		this.items[itemId].amount = parseInt(amount)
	},
	removeItem(itemId) {
		delete this.items[itemId]
	},
	replaceCart(items) {
		this.items = items		
	}
};